<style type="text/css" media="print">
  @page { size: landscape; }
</style>

<div id="impressao-controle-estoque">
  <div ng-repeat="recommendationSelectedItem in recommendationSelected" class="page-break">
    <div class="pendente-aprovacao-background" ng-if="recommendationSelected[0].situacao === 'aguardando_aprovacao' ">
      <svg width="100%" height="100%" style="transform:rotate(-45deg);" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400">
        <text x="25%" y="45%" style="fill: #cfcfcf73;">Pendente para aprovação</text>
      </svg>
    </div>
    <img ng-src="{{$root.parametros.imagem_report_url}}" ng-if="$root.parametros.imagem_report_url" class="logo">
    <div class="title-recomendacoes">
      Recomendação de Defensivos #{{recommendationSelectedItem.id}}
    </div>
    <br>
    <div ng-repeat="gleba in ::recommendationSelectedItem.glebas" ng-show="recommendationSelected[0].quebrarGleba" class="page-break">
      <ng-include src="'cabecalho.html'"></ng-include>

      <strong>Propriedade: </strong>{{::recommendationSelectedItem.propriedade.descricao | uppercase}}
      <br>
      <strong>Talhão: </strong>{{::gleba.descricao | uppercase}} ({{::gleba.area_total | number:2}} ha)
      <span class="side-space"></span>
      <strong>Cultura: </strong>{{::recommendationSelectedItem.atividade.descricao | uppercase}}
      </span>
      <br>
      <span ng-show="recommendationSelected[0].exibirInformacoes" ng-repeat="glebaCultivar in recommendationSelectedItem.glebas track by $index">
        <span ng-repeat="infoGleba in glebaCultivar.infoGleba">
          <br>
          <strong>Cultivar: </strong> {{infoGleba.cultivar || 'n/a'}}<br>
          <strong>Data emergência: </strong>{{(infoGleba.data_emergencia | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data de plantio: </strong>{{(infoGleba.data_inicio_plantio | date: 'dd/MM/yy') || 'n/a'}} a {{(infoGleba.data_fim_plantio | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data estimada colheita: </strong>{{(infoGleba.data_estimada_colheita | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Dias do ciclo até hoje: </strong>{{infoGleba.dias_ciclo || 'n/a'}}<br>
        </span>
      </span>
      <br>
      <ng-include src="'produtos-v2.html'"></ng-include>
      <ng-include src="'mais-detalhes.html'"></ng-include>
      <ng-include src="'maquina.html'"></ng-include>

      <div class="signatures col-xs-12">
        <print-signature style="margin-bottom: 2em;" label="Recomendante" name="recommendationSelectedItem.recomendante.nome_completo"></print-signature>
        <print-signature style="margin-bottom: 2em;" label="Responsável" name="recommendationSelectedItem.responsavel.nome_completo"></print-signature>
      </div>
    </div>

    <div ng-hide="recommendationSelected[0].quebrarGleba">
      <ng-include src="'cabecalho.html'"></ng-include>

      <strong>Propriedade: </strong>{{::recommendationSelectedItem.propriedade.descricao | uppercase}}
      <br>
      <strong>Talhões: </strong>
      <span ng-repeat="gleba in recommendationSelectedItem.glebas track by $index">
        <span ng-show="$index > 0">, </span>
        {{::gleba.descricao | uppercase}} ({{::gleba.area_total || 0 | number:2}} ha)
      </span>
      <span class="side-space"></span>
      <strong>Cultura: </strong>{{::recommendationSelectedItem.atividade.descricao | uppercase }}
      <br>
      <strong>Safra: </strong>{{::recommendationSelectedItem.safra.descricao}}
      <br>
      <span ng-show="recommendationSelected[0].exibirInformacoes" ng-repeat="glebaCultivar in recommendationSelectedItem.glebas track by $index">
        <span ng-repeat="infoGleba in glebaCultivar.infoGleba">
          <br>
          <strong>Cultivar: </strong> {{infoGleba.cultivar || 'n/a'}}<br>
          <strong>Data emergência: </strong>{{(infoGleba.data_emergencia | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data de plantio: </strong>{{(infoGleba.data_inicio_plantio | date: 'dd/MM/yy') || 'n/a'}} a {{(infoGleba.data_fim_plantio | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data estimada colheita: </strong>{{(infoGleba.data_estimada_colheita | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Dias do ciclo até hoje: </strong>{{infoGleba.dias_ciclo || 'n/a'}}<br>
        </span>
      </span>
      <br>
      <ng-include src="'produtos-v2.html'"></ng-include>
      <ng-include src="'mais-detalhes.html'"></ng-include>
      <ng-include src="'maquina.html'"></ng-include>

      <div class="signatures col-xs-12">
        <print-signature label="Recomendante" name="recommendationSelectedItem.recomendante.nome_completo"></print-signature>
        <print-signature label="Responsável" name="recommendationSelectedItem.responsavel.nome_completo"></print-signature>
      </div>
    </div>
  </div>
</div>

<script type="text/ng-template" id="produtos-v2.html">
  <div class="col-xs-12 no-padding">
    <table class="table no-padding styled-table small-font">
      <thead>
        <tr>
          <th class="no-padding-left col-xs-2">Produto</th>
          <th class="text-right">Dose</th>
          <th class="text-right" ng-show="recommendationSelectedItem.capacidadeTanque && (gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) >= 1">Tanque Cheio</th>
          <th class="text-right" ng-show="recommendationSelected[0].exibirTanqueParcial && recommendationSelectedItem.capacidadeTanque && getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) > 0">T. Parcial ({{getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) | number:2}}) <br>/ Água: {{getWaterApplication(recommendationSelectedItem.capacidadeTanque, getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas)) | number:0}} l</th>
          <th class="text-right">Total</th>
          <th class="text-right" style="width: 11%">Saídas</th>
          <th class="text-right" style="width: 11%">Devoluções</th>
          <th class="text-right" style="width: 11%">Qtd. Utilizada</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="produto in ::recommendationSelectedItem.insumos track by $index" class="small">
          <td class="col-xs-2 vertical-middle">{{::produto.descricao}}</td>
          <td class="text-right">{{produto.dose | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}/ha</td>
          <td class="text-right" ng-show="recommendationSelectedItem.capacidadeTanque && (gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) >= 1">{{produto.capacidade.totalTanque | formatDynamicDecimals}} {{produto.capacidade.abreviatura}}</td>
          <td class="text-right" ng-show="recommendationSelected[0].exibirTanqueParcial && recommendationSelectedItem.capacidadeTanque && getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) > 0">{{getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) *  produto.capacidade.totalTanque | formatDynamicDecimals}} {{produto.capacidade.abreviatura}}</td>
          <td class="text-right">{{calculateTotalProduto(produto, gleba.area_total || recommendationSelectedItem.area_total_recomendada, !!recommendationSelected[0].quebrarGleba && recommendationSelectedItem.glebas.length > 1) | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}</td>
          <td style="width: 11%"></td>
          <td style="width: 11%"></td>
          <td style="width: 11%"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <br>
</script>

<script type="text/ng-template" id="maquina.html">
  <div ng-show="recommendationSelected[0].exibirInformacoes">
    <strong>Máquina:</strong>
    <br>
    <br>
    <div class="col-xs-12 no-padding">
      <div class="col-xs-9 no-padding-left">
        <table class="table styled-table">
          <thead>
            <tr>
              <th class="text-center">Data</th>
              <th class="text-center">Hora</th>
              <th class="text-center">Vazão</th>
              <th class="text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="i in [1, 2, 3, 4, 5]">
              <td style="height: 30px"></td>
              <td style="height: 30px"></td>
              <td style="height: 30px" class="col-xs-1"></td>
              <td style="height: 30px"></td>
            </tr>
          </tbody>
        </table>      
      </div>
    </div>
  </div>
</script>

<script type="text/ng-template" id="table-maquina.html">
    
  </div>
</script>
  
